import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { i18nActions } from './i18n.actions';
import { getSvelteService, SvelteService } from '@bl/components/dist/wrappers';
import type { TranslationConfig, TranslationsService } from '@bl/components/dist/services/types';

@Injectable()
export class I18nEffects {
  private actions$: Actions = inject(Actions);
  private translocoService: TranslocoService = inject(TranslocoService);

  languageChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(i18nActions.languageChange),
      map(({ languageCode }) => {
        this.translocoService.setActiveLang(languageCode);
        return i18nActions.languageChanged({ languageCode });
      }),
    ),
  );

  updateTranslations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(i18nActions.languageChanged),
      switchMap(({ languageCode }) => this.translocoService.selectTranslation(languageCode).pipe(first(Boolean))),
      tap((translations) => {
        this.updateBlComponentsTranslations(translations);
      }),
      map((translations) => i18nActions.translationsUpdated({ translations })),
    ),
  );

  private updateBlComponentsTranslations(translations: Record<string, string>): void {
    const BL_COMPONENTS_PREFIX = '@bl-components.';
    const blComponentsTranslationKeys = Object.keys(translations).filter((key) => key.startsWith(BL_COMPONENTS_PREFIX));
    const blComponentsTranslations = blComponentsTranslationKeys.reduce((blComponentTranslations, key) => {
      const newKey = key.replace(BL_COMPONENTS_PREFIX, '');
      blComponentTranslations[newKey] = translations[key];
      return blComponentTranslations;
    }, {} as TranslationConfig);

    getSvelteService<TranslationsService>(SvelteService.TranslationsService).setTranslations({
      ...blComponentsTranslations,
    });
  }
}
